import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import {
    selectActiveUserProfile,
    selectParentalControlRating,
    selectProfilesList,
} from 'store/user/selectors';

import getParentalRating from 'utils/getParentalRating';

const useProfileParentalRating = () => {
    const profiles = useSelector(selectProfilesList);
    const selectedProfileId = useSelector(selectActiveUserProfile);
    const userParentalControlRating = useSelector(selectParentalControlRating);

    const selectedProfile = useMemo(
        () => profiles.find(({ _id }) => _id === selectedProfileId),
        [profiles, selectedProfileId],
    );

    return getParentalRating(userParentalControlRating, selectedProfile);
};

export default useProfileParentalRating;
